import '../styles/Footer.css';
import logo from '../assets/img/logo-abbvie-vraie-vie.png';
import { Link } from 'react-router-dom';
import Menu from './Menu';
import TwitterIcon from '../assets/img/footer-twitter.svg';
import LinkedinIcon from '../assets/img/footer-linkedin.svg';
import YoutubeIcon from '../assets/img/footer-youtube.svg';

function Footer() {

  return (
    <>
      <footer>
        <div className="medium-container site-footer">
          <div className='col1'>
            <Link to='/'><img src={logo} alt='Abbvie Vraie Vie'/></Link>
            <p>Ce site est dédié aux AP, AC, <br/> CPC et RUSD de AbbVie</p>
          </div>
          <div className='col2'>
            <Menu />
          </div>
          <div className='col3'>
            <p className='col-title'>LIENS EXTERNES</p>
            <ul>
              <li><Link to='https://www.abbvie.fr/' target='_blank' className='external-link'>www.abbvie.fr</Link></li>
            </ul>
          </div>
        </div>
        <div className="medium-container footer-bottom">
          <ul>
            <li><Link to={'/conditions-generales-d-utilisation'}>Conditions générales d’utilisation</Link></li>
            <li><Link to={'/politique-de-confidentialite'}>Politique de confidentialité</Link></li>
            <li><Link to={'/declaration-daccessibilite'}>Déclaration d'accessibilité</Link></li>
            <li><Link to={'https://www.studio-calico.fr/'} target='_blank'>Réalisation Calico</Link></li>
          </ul>
          <ul className='list-social'>
            <li><Link target="_blank" to={'https://x.com/AbbVieFrance'}><img src={TwitterIcon} alt="Twitter" /></Link></li>
            <li><Link target="_blank" to={'https://www.linkedin.com/company/abbvie'}><img src={LinkedinIcon} alt="Linkedin" /></Link></li>
            <li><Link target="_blank" to={'https://www.youtube.com/channel/UC023GwYXeUQQ6TYHlCaxjOA'}><img src={YoutubeIcon} alt="Youtube" /></Link></li>
          </ul>
        </div>
      </footer>
    </>
  )
}

export default Footer